import axios from 'axios';
import api from './api';

export const listDrives = (body) =>
  api.post(
    `/v1/workspace/vault/list`,
    body
  );

export const createDrive = (body) => {
    return api.post(`/v1/workspace/vault/create`, body);
};

export const renameDrive = (body) => {
    return api.post(`/v1/vault/rename`, body);
};